var moduleMap = {
	"./AuthStore": () => {
		return __webpack_require__.e("apps_ofplatform_ofassembler_src_store_index_ts").then(() => (() => ((__webpack_require__("./apps/@ofplatform/ofassembler/src/store/index.ts")))));
	},
	"./OrderStore": () => {
		return __webpack_require__.e("apps_ofplatform_ofassembler_src_store_index_ts").then(() => (() => ((__webpack_require__("./apps/@ofplatform/ofassembler/src/store/index.ts")))));
	},
	"./DealerStore": () => {
		return __webpack_require__.e("apps_ofplatform_ofassembler_src_store_index_ts").then(() => (() => ((__webpack_require__("./apps/@ofplatform/ofassembler/src/store/index.ts")))));
	},
	"./NavStore": () => {
		return __webpack_require__.e("apps_ofplatform_ofassembler_src_store_navStore_ts").then(() => (() => ((__webpack_require__("./apps/@ofplatform/ofassembler/src/store/navStore.ts")))));
	},
	"./LanguageStore": () => {
		return __webpack_require__.e("apps_ofplatform_ofassembler_src_store_languageStore_ts").then(() => (() => ((__webpack_require__("./apps/@ofplatform/ofassembler/src/store/languageStore.ts")))));
	},
	"./i18n": () => {
		return __webpack_require__.e("apps_ofplatform_ofassembler_src_config_i18n_ts").then(() => (() => ((__webpack_require__("./apps/@ofplatform/ofassembler/src/config/i18n.ts")))));
	},
	"./useBFF": () => {
		return __webpack_require__.e("packages_smart-function_src_hooks_useBFF_ts").then(() => (() => ((__webpack_require__("./packages/@smart-function/src/hooks/useBFF.ts")))));
	},
	"./useAmplitudeTracker": () => {
		return __webpack_require__.e("packages_smart-function_src_hooks_useAmplitudeTracker_ts").then(() => (() => ((__webpack_require__("./packages/@smart-function/src/hooks/useAmplitudeTracker.ts")))));
	},
	"./GlobalErrorHandling": () => {
		return __webpack_require__.e("apps_ofplatform_ofassembler_src_components_GlobalErrorHandling_index_ts").then(() => (() => ((__webpack_require__("./apps/@ofplatform/ofassembler/src/components/GlobalErrorHandling/index.ts")))));
	},
	"./ModalOrchestrator": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__("./packages/@shared/components/src/lib/modal-system/ModalOrchestrator.tsx")))));
	},
	"./ModalHandler": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__("./packages/@shared/components/src/lib/modal-system/ModalHandler.tsx")))));
	},
	"./useRegisterModals": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__("./packages/@shared/components/src/lib/modal-system/useRegisterModals.ts")))));
	},
	"./useModalDispatch": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__("./packages/@shared/components/src/lib/modal-system/useModalDispatch.ts")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});